import pixNProgress from '@/shared/pixNProgress.js';
import store from '@/store/index.js';
import modeConst from '@/consts/mode.const.js';

/**
 * This guard prevents the loading of the specific property tab component when the tab does not included in the tab configuration by instance.
 */
const propertyTabGuard = (tabId) => async (to, from, next) => {
  const tab = store.getters['genericConfigModule/getTab'](tabId, modeConst.PROPERTY);
  // Only let pass if the tab exists in the configuration.
  if (tab) {
    store.commit('propertyModule/setSelectedTab', tabId);
    // Load the tab configuration.
    store.dispatch('genericConfigModule/loadGenericTabConfig', tab.RowId);
    next();
  } else {
    pixNProgress.forceFinish();
    store.dispatch('toastModule/error', 'Unauthorized');
    next(false);
  }
};

export default propertyTabGuard;
